import React from 'react';
import { Box, Inscription, TextWithParagraphs } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { RenewalPlanYear } from '@/modules/Renewals/renewals.types.ts';

import { RenewalPlanOptionValues } from '../RenewalSetup.types';
import { useRenewalSetupStore } from '../stores';

interface Props {
  planYear?: RenewalPlanYear;
  isCanceled?: boolean;
  planRenewalNote?: string;
  isRequested?: boolean;
}

const PlansNoteDetails: React.FC<Props> = ({ planYear, isCanceled, planRenewalNote, isRequested }) => {
  const planDetailsNote = useRenewalSetupStore((state) => state.planDetailsNote);
  const plansPlanYearSelectedOption = useRenewalSetupStore((state) => state.plansPlanYear.selectedOption);

  return (
    <Box gap="s">
      {plansPlanYearSelectedOption !== RenewalPlanOptionValues.CANCELED && !isCanceled && !isRequested && (
        <Box direction="row" align="center" justify="between">
          <Inscription size="medium" color="textBody">
            First and last date of plan year:
          </Inscription>
          <Inscription size="medium" color="textBody" weight="bold">
            {dayjs(planYear?.validFrom).format(DEFAULT_DATE_FORMAT)} -{' '}
            {planYear?.validTo ? dayjs(planYear?.validTo).format(DEFAULT_DATE_FORMAT) : ''}
          </Inscription>
        </Box>
      )}
      <Box
        background="canvas"
        pad={{ horizontal: 'l', vertical: 'm' }}
        round="container1Round"
        border={{ color: 'border1' }}
      >
        <Inscription color="textBody" margin={{ bottom: 'spacing4' }} weight="bold">
          {plansPlanYearSelectedOption === RenewalPlanOptionValues.CANCELED || isCanceled
            ? 'Reason for not renewing:'
            : 'Renewal details:'}
        </Inscription>
        <TextWithParagraphs text={planRenewalNote || planDetailsNote || ''} />
      </Box>
    </Box>
  );
};

export default PlansNoteDetails;
